import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getStudents, getStudentById } from '../store/slices/studentsSlice';

export const useStudents = (branchId) => {
  const dispatch = useDispatch();
  const [students, setStudents] = useState([]);
  const { loading, selectedStudent } = useSelector((state) => state.students);

  const fetchStudents = () => {
    if (!branchId) {
      setStudents([]);
      return;
    }
    
    // Return the promise chain so callers can await to avoid interleaved updates
    return dispatch(getStudents(branchId)).unwrap()
      .then((data) => {
        setStudents(data?.items || data || []);
        return data;
      })
      .catch((err) => {
        setStudents([]);
        throw err;
      });
  };

  const fetchStudentById = (id) => {
    return dispatch(getStudentById(id));
  };

  useEffect(() => {
    fetchStudents();
  }, [dispatch, branchId]);

  return {
    students,
    selectedStudent,
    loading,
    refetchStudents: fetchStudents,
    fetchStudentById
  };
}; 